import React from "react";
import styled from "styled-components";
import { Trans, useTranslation } from "react-i18next";
import { Table } from "components/bootstrap";
import { Icon } from "components/common";
const SectionTitle = styled.p`
  font-weight: bold;
  font-size: 1.2em;
  margin: 0 0 12px;
`;
const SectionNote = styled.p`
  font-style: italic;
  margin: 3px 0 0;
`;
const StyledTable = styled(Table)`
  margin: 0;
`;
const AWSAutomaticAuthentication = () => {
  const { t } = useTranslation("enterprise_archive");
  return /* @__PURE__ */ React.createElement(StyledTable, { condensed: true }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", { colSpan: 2 }, /* @__PURE__ */ React.createElement(SectionTitle, null, t("aws_automatic_authentication.intro"))))), /* @__PURE__ */ React.createElement("tbody", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, t("aws_automatic_authentication.environment_variables")), /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "aws_automatic_authentication.environment_variables_value",
      values: { first: "AWS_ACCESS_KEY_ID", second: "AWS_SECRET_ACCESS_KEY" },
      components: { code: /* @__PURE__ */ React.createElement("code", null) }
    }
  ))), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, t("aws_automatic_authentication.java_system_properties")), /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "aws_automatic_authentication.java_system_properties_value",
      values: { first: "aws.accessKeyId", second: "aws.secretKey" },
      components: { code: /* @__PURE__ */ React.createElement("code", null) }
    }
  ))), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, t("aws_automatic_authentication.credential_profiles")), /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "aws_automatic_authentication.credential_profiles_value",
      values: { path: "~/.aws/credentials" },
      components: { code: /* @__PURE__ */ React.createElement("code", null) }
    }
  ))), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, t("aws_automatic_authentication.ecs_credentials")), /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "aws_automatic_authentication.ecs_credentials_value",
      values: { variable: "AWS_CONTAINER_CREDENTIALS_RELATIVE_URI" },
      components: { code: /* @__PURE__ */ React.createElement("code", null) }
    }
  ))), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, t("aws_automatic_authentication.instance_profile")), /* @__PURE__ */ React.createElement("td", null, t("aws_automatic_authentication.instance_profile_value")))), /* @__PURE__ */ React.createElement("tfoot", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", { colSpan: 2 }, /* @__PURE__ */ React.createElement(SectionNote, null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "aws_automatic_authentication.more_information",
      components: {
        docsLink: /* @__PURE__ */ React.createElement(
          "a",
          {
            href: "https://docs.aws.amazon.com/cli/latest/userguide/cli-configure-files.html",
            target: "_blank",
            rel: "noopener noreferrer"
          }
        ),
        icon: /* @__PURE__ */ React.createElement(Icon, { name: "open_in_new" })
      }
    }
  ))))));
};
export default AWSAutomaticAuthentication;
